import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { DownloadBlobsRequest } from "generated-types";
import { KB_SOURCE } from "util/constants";

import axios from "@/configs/axios";

export const usePostDownloadBlobs = (): UseMutationResult<
  { data: Blob; status: number },
  Error,
  DownloadBlobsRequest,
  unknown
> => {
  const fetchBlobs = useCallback(
    async (payload: DownloadBlobsRequest): Promise<{ data: Blob; status: number }> => {
      const url = `${process.env.REACT_APP_SERVER_HOST}/downloadBlobs/?source=${KB_SOURCE}`;
      const response = await axios.post(url, payload, {
        responseType: "blob", // To receive binary data
        headers: {
          "Cache-Control": "no-store",
        },
      });

      return { data: response.data, status: response.status };
    },
    []
  );
  return useMutation<{ data: Blob; status: number }, Error, DownloadBlobsRequest, unknown>({
    mutationFn: fetchBlobs,
  });
};
